import { render, staticRenderFns } from "./MonthStatisticDialog.vue?vue&type=template&id=22095a92&scoped=true&lang=pug&"
import script from "./MonthStatisticDialog.vue?vue&type=script&lang=ts&"
export * from "./MonthStatisticDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MonthStatisticDialog.vue?vue&type=style&index=0&id=22095a92&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22095a92",
  null
  
)

export default component.exports